import axios from "axios";
import { SERVER_URL } from "../const";




export const getDropdownByName = async (dropdown_name) => {
  const token = localStorage.getItem('token');
    try {
      // Make a GET request to the API endpoint using Axios
      const response = await axios.get(`${SERVER_URL}/dropdown/${dropdown_name}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
  
      return response.data;
    } catch (error) {
      // Handle errors
      console.error('Error:', error);
    }
};


export const getDropdownChildren = async (dropdown_name, parent_id) => {
  const token = localStorage.getItem('token');
    try {
      // Make a GET request to the API endpoint using Axios
      const response = await axios.get(`${SERVER_URL}/dropdown/${dropdown_name}/children/${parent_id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
  
      return response.data;
    } catch (error) {
      // Handle errors
      console.error('Error:', error);
    }
};